import { render, staticRenderFns } from "./FilterDoc.vue?vue&type=template&id=1fdfe50a"
import script from "./FilterDoc.vue?vue&type=script&lang=js"
export * from "./FilterDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports